module.exports = __webpack_public_path__ + "static/campaigns_icon-7c2c77c963d7c460e0c0fccd7e48df0f.png";